/* Small native route accents. No interception of filters, forms, variants, quantities or checkout. */
(() => {
  if (!('IntersectionObserver' in window)) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 749px)');
  const tracked = new Set();
  let frame = 0;
  const enabled = () => !reduced.matches && !mobile.matches;
  const observer = new IntersectionObserver(entries => entries.forEach(entry => { entry.target.dataset.digiVisible = String(entry.isIntersecting); if(entry.isIntersecting) request(); }), {rootMargin:'40px',threshold:0});
  function update() {
    frame = 0;
    for (const root of tracked) {
      if(!root.isConnected) {observer.unobserve(root);tracked.delete(root);continue;}
      if (!enabled() || document.hidden) {root.style.setProperty('--digi-route-y','0px');root.style.setProperty('--digi-heading-scale','1');continue;}
      if (root.dataset.digiVisible!=='true') continue;
      const rect=root.getBoundingClientRect();
      const p=Math.max(0,Math.min(1,(innerHeight-rect.top)/(innerHeight+rect.height)));
      root.style.setProperty('--digi-route-progress',p.toFixed(3));
      root.style.setProperty('--digi-route-y',((p-.5)*12).toFixed(2)+'px');
      root.style.setProperty('--digi-heading-scale',(.75+p*.25).toFixed(3));
    }
  }
  function request(){if(!frame)frame=requestAnimationFrame(update);}
  function scan(container=document) {
    if (document.body.classList.contains('digi-page-index')) container.querySelectorAll('#MainContent .shopify-section h2').forEach(heading=>{if(heading.closest('[data-digi-upgrade-scene]')||heading.closest('.card-wrapper'))return;heading.classList.add('digi-journey-heading');heading.setAttribute('data-digi-route-motion','');});
    container.querySelectorAll('[data-digi-route-motion]').forEach(root=>{if(tracked.has(root))return;tracked.add(root);observer.observe(root);});request();
  }
  window.addEventListener('scroll',()=>{if(enabled()&&!document.hidden)request();},{passive:true});
  window.addEventListener('resize',request,{passive:true});
  reduced.addEventListener('change',request);mobile.addEventListener('change',request);document.addEventListener('visibilitychange',request);
  document.addEventListener('shopify:section:load',event=>scan(event.target));
  document.addEventListener('shopify:section:unload',event=>{for(const root of tracked)if(event.target.contains(root)){observer.unobserve(root);tracked.delete(root);}});
  scan();
})();
